<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        v-if="id === ''"
        @back="back"
        title
        :content="$t('adicionar-novo-destinatario')"
      ></el-page-header>
      <el-page-header
        v-if="id !== ''"
        @back="back"
        title
        :content="$t('atualizar-destinatario')"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-position="top"
        :status-icon="true"
        :rules="rules"
        :inline-message="true"
      >
        <el-form-item
          :label="user.type === '1' || user.type === '3' ? $t('cliente') : $t('filial')"
          prop="customer"
          v-if="user.type !== '5' && !id"
        >
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <CustomerList
              v-model="ruleForm.customer"
              v-bind:current="ruleForm.customer"
              v-bind:customerType="user.type === '2' ? 3 : ''"
            />
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('nome')" prop="name">
          <el-input ref="name" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-row :gutter="5">
          <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('cep')" prop="cep">
              <el-input
                maxlength="9"
                v-model="ruleForm.cep"
                v-mask="'#####-###'"
                @blur="zipcode()"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="16" :md="16" :lg="11" :xl="11">
            <el-form-item :label="$t('endereco')" prop="address">
              <el-input v-model="ruleForm.address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('bairro')" prop="neighborhood">
              <el-input v-model="ruleForm.neighborhood"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="6" :xl="6">
            <el-form-item :label="$t('cidade')" prop="city">
              <el-input v-model="ruleForm.city"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="2" :xl="2">
            <el-form-item :label="$t('estado')" prop="state">
              <el-input v-model="ruleForm.state" class="text-uppercase" maxlength="2"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="6" :md="6" :lg="2" :xl="2">
            <el-form-item :label="$t('numero')" prop="number">
              <el-input
                type="number"
                maxlength="6"
                v-model="ruleForm.number"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('complemento')" prop="extent">
              <el-input v-model="ruleForm.extent"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('telefone')" prop="phone">
              <el-input
                ref="phone"
                v-model="ruleForm.phone"
                v-mask="'(##) ####-####'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('celular')" prop="mobile">
              <el-input
                ref="mobile"
                v-model="ruleForm.mobile"
                v-mask="['(##) ####-####', '(##) #####-####']"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item :label="$t('email')" prop="mail">
              <el-input maxlength="160" v-model="ruleForm.mail"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <br />
        <el-form-item style="text-align: center">
          <el-button
            type="warning"
            v-if="id === ''"
            autofocus
            @click="submitForm('ruleForm')"
            >{{ $t("adicionar") }}</el-button
          >
          <el-button
            type="warning"
            v-if="id !== ''"
            autofocus
            @click="editForm('ruleForm')"
            >{{ $t("atualizar") }}</el-button
          >
          <el-button type="danger" @click="back()">{{
            $t("voltar")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { i18n } from "@/plugin/i18n";
import { DeliveryService } from "@/services/delivery/delivery.services";
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ZipMixins from "../../../mixins/zipcode";

export default {
  name: "DeliveryAdd",
  mixins: [ZipMixins],
  components: {
    CustomerList,
  },
  data() {
    const checkState = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Estado é obrigatório'));
      }
      const list = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];
      const state = list.find(x => x === value.toUpperCase());
      if (!state) {
        callback(new Error('Estado informado é inválido!'));
      } else {
        callback();
      }
    };
    return {
      id: "",
      user: {
        type: "2",
      },
      ruleForm: {
        name: "",
        customer: "",
        address: "",
        cep: "",
        city: "",
        state: "",
        neighborhood: "",
        number: "",
        extent: "",
        mobile: "",
        phone: "",
        mail: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-obrigatorio"),
            trigger: "blur",
          },
        ],
        cep: [
          {
            required: true,
            message: i18n.tc("cep-obrigatorio"),
            trigger: "blur",
          },
        ],
        state: [
          { validator: checkState, trigger: 'blur' }          
        ],
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.replace({
        name: "delivery",
      });
    },
    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      DeliveryService.get(vm.id)
        .then((response) => {
          vm.ruleForm.customer = response.customer.id;
          vm.ruleForm.name = response.name;
          vm.ruleForm.number = response.number;
          vm.ruleForm.extent = response.extent;
          vm.ruleForm.phone = response.phone;
          vm.ruleForm.mobile = response.mobile;
          vm.ruleForm.mail = response.mail;
          vm.ruleForm.address = response.address;
          vm.ruleForm.cep = response.zipcode.zipcode;
          vm.ruleForm.city = response.city;
          vm.ruleForm.state = response.state;
          vm.ruleForm.neighborhood = response.neighborhood;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          DeliveryService.add(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("destinatario-adicionado-sucesso"),
              });
              this.$refs[formName].resetFields();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          DeliveryService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("destinatario-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        if (vm.$route.params.id) {
          vm.id = vm.$route.params.id;
          vm.get();
        } else {
          vm.$refs.name.$el.children[0].focus();
        }
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}
form {
  margin-top: 20px;
}
@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
.text-uppercase .el-input__inner {
  text-transform: uppercase;
}
</style>
